<template>
  <div>
    <div class="hidden l:grid w-full m:h-full grid-cols-12 fixed">
      <div class="col-span-4" />
      <div class="col-start-9 col-span-4 bg-pale-mint-grey" />
    </div>

    <header-component :content-props="{ hasUserMenu: true, hasUpgradeLink: false }" />

    <div
      class="container m:grid m:grid-cols-12 pb-12 m:pb-16 relative m:h-full lg:px-0"
    >
      <div class="col-span-full m:col-span-10 l:col-span-6 pt-6 m:pt-8 l:pt-16">
        <b-headline type="h1" typography="h2" class="mb-4 m:mb-6" v-html="$t('pages.platinum.headline')" />

        <p v-html="copy" class="mb-4 m:mb-6" />

        <purchase-image class="hidden m:block" />
      </div>

      <div class="hidden m:block row-span-3 col-start-8 col-span-5 pl-16 bg-pale-mint-grey pt-8">
        <p class="text-p0 text-center">
          {{ $t('pages.platinum.next') }}
        </p>
        <features />
      </div>
    </div>

    <div class="m:hidden">
      <p class="container">
        {{ $t('pages.platinum.next') }}
      </p>

      <div class="container bg-pale-mint-grey">
        <features />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "@/features/header/components"
import BHeadline from "@/component-library/b-headline"
import PurchaseImage from "@/pages/success-page/components/platinum/image"
import { mapGetters } from "vuex"
import Features from "./features"

export default {
  name: "PurchaseSuccess",
  components: {
    HeaderComponent,
    PurchaseImage,
    BHeadline,
    Features
  },
  computed: {
    ...mapGetters(["usersEmail"]),
    copy() {
      return this.$t(`pages.platinum.body`, { usersEmail: this.usersEmail })
    },
    purchaseType() {
      const urlParams = new URLSearchParams(window.location.search);

      return urlParams.get("purchaseType");
    }
  },
  mounted() {
    this.$store.dispatch("loadUsersAccounts")
  }
}
</script>
